<template>
  <BaseDialog
    centered
    contentClass="add-evaluation-grid-template"
    ref="dialog"
    persistent
    show-actions
    @closeModal="closeDialog"
  >
    <template #title>
      {{ dialogTitle }}
    </template>
    <template #content>
      <form @submit.prevent="onSubmit" class="add-evaluation-grid-template__form" @keydown.enter="handleEnterPress">
        <div class="form-section">
          <FormInput
            ref="name"
            :label="$t('page.admin-evaluation-grid.name')"
            is-required
            has-gray-background
            name="name"
            type="text"
            v-model="name"
            v-validate="'required'"
          />
          <FormCheckbox :label="$t('page.admin-evaluation-grid.make-default')" v-model="makePrimary"></FormCheckbox>
        </div>
        <div class="add-evaluation-grid-template__actions">
          <FormButton is-outlined class="add-evaluation-grid-template__cancel" @click.native="cancelClick">
            {{ $t('actions.cancel') }}
          </FormButton>
          <FormButton type="submit" :disabled="isFormInvalid">
            <span>{{ buttonText }}</span>
          </FormButton>
        </div>
      </form>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import FormButton from '@/components/form/FormButton';
import FormInput from '@/components/form/FormInput.vue';
import { mapActions } from 'vuex';
import FormCheckbox from '@/components/form/FormCheckbox.vue';

export default {
  name: 'AddEvaluationGridTemplate',
  components: {
    FormCheckbox,
    BaseDialog,
    FormButton,
    FormInput,
  },
  data() {
    return {
      name: '',
      makePrimary: false,
    };
  },
  computed: {
    dialogTitle() {
      return this.$t('page.admin-evaluation-grid.add-template');
    },
    buttonText() {
      return this.$t('actions.add');
    },
    isFormInvalid() {
      return !this.name;
    },
  },
  methods: {
    ...mapActions('evaluationGridTemplates', ['addEvaluationGridTemplate']),
    openDialog() {
      this.name = '';
      this.makePrimary = false;
      this.$refs.dialog.openModal();
      this.$nextTick(() => {
        const refInput = this.$refs.name.$el.querySelector('input');
        if (refInput) {
          this.$nextTick(() => refInput.focus());
        }
      });
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
    onSubmit() {
      if (!this.$refs.dialog.isModalOpen) return;
      if (this.isFormInvalid) {
        this.$toast.error(this.$t('errors.missingFields'));
        return;
      }
      this.addEvaluationGridTemplate({ name: this.name, isPrimary: this.makePrimary })
        .then(() => {
          this.$toast.success(this.$t('page.admin-evaluation-grid.toast.add-template-success'));
          this.$emit('action-succeeded');
          this.closeDialog();
        })
        .catch((error) => {
          this.$toast.error(error);
        });
    },
    cancelClick() {
      this.closeDialog();
    },
    handleEnterPress(event) {
      if (this.isFormInvalid) {
        event.preventDefault();
      } else {
        this.onSubmit();
      }
    },
  },
};
</script>

<style lang="scss">
.add-evaluation-grid-template__form {
  .form-input {
    padding-bottom: 16px;
  }
  .add-evaluation-grid-template__actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 32px;
  }
  .add-evaluation-grid-template__cancel {
    margin-right: 12px;
  }
}
.base-dialog__add-evaluation-grid-template {
  height: auto;
  width: 500px;
  position: relative;
  border-radius: $border-radius-root;

  .base-dialog__content {
    background: $color-white !important;
    padding: 32px !important;
  }
}
</style>
